import Resource from './Resource';

/**
 * OfferToPurchase Resource
 */
class OfferToPurchase extends Resource
{
    constructor() {
        super('vehicle.purchase.offer', ['vehicles', null, 'offers-to-purchase']);
    }

    forVehicle(id) {
        this.resourceSegments[1] = id;

        return this
    }
}   

export let OfferToPurchaseResource = new OfferToPurchase();

/**
 * OfferToPurchase Schema
 * @param {Object} defaults [description]
 */
export let OfferToPurchaseSchema = function(defaults = {}) {
    let schema = {
        amount: null, 
        contact_id: null, 
        vehcle_id: null,
        instance_id: null,
        notes: null,
        has_been_seen: false,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};